/*
 * Заглушка раздела — по фрейму «Заглушка раздела» макета «Мастер, доступ и заглушка — П1».
 *
 * БЛОК СТОИТ ПО ЦЕНТРУ РАБОЧЕЙ ОБЛАСТИ, а не карточкой в левом верхнем углу. Маленькая
 * пунктирная карточка у края огромной пустой страницы читалась как недогруженный экран
 * или сбой: человек ждал, что остальное вот-вот появится. По центру и без рамки это
 * законченное сообщение — «здесь пока ничего нет, и вот куда идти».
 *
 * Размеры — из макета: ширина текста до 400 px, заголовок 16/600, текст 13 px с высокой
 * строкой, одна кнопка второго уровня.
 */
.wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: var(--space-6) var(--space-4);
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 400px;
  text-align: center;
}

.title {
  margin: 0;
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  text-wrap: balance;
}

.text {
  margin: 0;
  font-size: var(--font-size-base);
  line-height: 1.55;
  color: var(--text-brand);
  text-wrap: pretty;
}

.actions {
  display: flex;
  justify-content: center;
  margin-top: var(--space-1);
}
